/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  background: #e2e8f0;
  padding: 5px;
  display: flex;
  justify-content: center;
  width: 600px;
`;
